<template>
  <div class="person-item">
    <!-- <div class="bk"> -->
    <el-popover ref="popover"
                placement="right"
                width="200"
                trigger="hover"
                :content="statusObj.tips">
    </el-popover>
    <div class="hidden"
         v-if="data.status!==0">
      <div>{{statusObj.name}}</div>
    </div>
    <!-- </div> -->
    <div @click="jumpDetail"
         v-if="data.status!==0"
         style="cursor:pointer"
         v-popover:popover>
      <el-image v-if="type === 'old'"
                class="img"
                fit="cover"
                :src="imgUrl+data.oldObjectImages[0].url" />
      <el-image v-else
                class="img"
                fit="cover"
                :src="data.imageUrl?imgUrl+data.imageUrl:defaultImg" />
      <!-- <div class="img"></div> -->
    </div>
    <div @click="jumpDetail"
         style="cursor:pointer"
         v-if="data.status===0">
      <el-image v-if="type === 'old'"
                class="img"
                fit="cover"
                :src="imgUrl+data.oldObjectImages[0].url" />
      <el-image v-else
                class="img"
                fit="cover"
                :src="data.imageUrl?imgUrl+data.imageUrl:defaultImg" />
      <!-- <div class="img"></div> -->
    </div>
    <div class="goods-title">{{ type === "old" ? data.name : data.title }}</div>
    <div class="operate"><span @click="edit">修改</span><span @click="del">删除</span></div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import { deleteGoods } from "@/http/goods"
import { deleteGrace } from "@/http/grace.api"
import defaultImg from "@/assets/old_default.jpg";
@Component
export default class PersonCenterListItem extends Vue {
  @Prop({
    required: true,
    default: () => []
  }) data;
  @Prop({
    required: true,
    type: String
  }) url

  @Prop({
    type: String,
    default: "old"
  }) type;
  defaultImg = defaultImg;
  get statusObj () {
    const { status } = this.data
    const res = {}
    if (status !== 0) {
      if (status === -1) {
        res.name = '待审核'
        res.tips = '该内容正在审核中，审核通过后可在网站中查阅'
      } else {
        res.name = '已隐藏';
        res.tips = '您发布的内容存在争议已被隐藏显示'
      }
    }
    return res;
  }
  edit () {
    const path = this.type === 'old' ? `/old/add` : `/grace/add`
    this.$router.push({ path, query: { id: this.data.id } })
  }
  jumpDetail () {
    if (this.data.status !== 0) return;
    this.$router.push(`${this.url}${this.data.id}`)
  }
  async del () {
    const res = await this.$confirm('是否删除该内容?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    if (!res) return;
    const dele = this.type === 'old' ? deleteGoods : deleteGrace;
    await dele({ id: this.data.id })
    this.$alert('删除成功')
    this.$emit('update')
  }
  get imgUrl () {
    return window.StaticUrl
  }
  mounted () {
    console.log(this.type, this.data);
  }
}
</script>

<style lang="scss" scoped>
.person-item {
  // margin-right: 30px;
  width: 23%;
  margin-right: 2%;
  margin-bottom: 40px;
  position: relative;
  // .bk{
  //   position: ;
  // }
  .hidden {
    position: absolute;
    top: -37px;
    right: -37px;
    z-index: 1000;
    color: white;
    font-size: 12px;
    width: 34px;
    height: 34px;
    transform: rotate(45deg);
    border-width: 20px;
    border-style: solid;
    border-color: transparent transparent #d52f09 transparent;
    div {
      position: absolute;
      bottom: -17px;

      font-size: 12px;
      // -webkit-transform-origin-x: 0;
      transform: scale(1, 0.2);
      transform: rotate(-0deg);
      letter-spacing: 1px;
      white-space: nowrap;
    }
  }

  .img {
    width: 212px;
    height: 122px;
    background-color: #ccc;
  }
  .goods-title {
    color: #343434;
    font-size: 18px;
    padding: 20px 0;
    white-space: normal;
  }
  .operate {
    font-size: 13px;
    color: #343434;
    span {
      cursor: pointer;
    }
    span:first-child {
      margin-right: 20px;
    }
  }
}
</style>
